import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  formContainer: { maxWidth: '900px', margin: '0 auto' },
}));
